export function fmtObjectRetention(days) {
    try {
      return days>0?(`${days} day${days==1?'':'s'}`):"UNLIMITED";
    } catch {
      return "";
    }
}
